export default "__VITE_ASSET__BK88Ozn1__"